import { MedicalInformationAttachment } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { AttachmentLink } from '@dreryk/react-components';

type AttachmentsLinksViewProps = Readonly<{
   attachments: MedicalInformationAttachment[];
}>;

export const AttachmentsLinksView = (props: AttachmentsLinksViewProps): JSX.Element => {
   return (
      <>
         {props.attachments.map((attachment) => (
            <AttachmentLink
               testId={attachment.id.toString()}
               key={attachment.downloadUrl}
               name={attachment.name}
               downloadUrl={attachment.downloadUrl}
            />
         ))}
      </>
   );
};
